<template>
  <component :is="layout">
    <template>
      <slot />
    </template>
  </component>
</template>

<script>
export default {
  name: "TheLayout",
  computed: {
    layout() {
      const layout = this.$route?.meta?.layout || "/EmptyLayout";
      return () => import(`.${layout}`);
    },
  },
};
</script>
